import React from 'react';
import { Box, Typography, Modal, Button } from '@mui/material';
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useUserAndGameContext } from '../../../contexts/UserAndGameContext';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import EastIcon from '@mui/icons-material/East';

const ContentModal = ({ open, onClose, activeModal }) => {
  const { gameData } = useUserAndGameContext();
  
  // Get the modal content from gameData
  const menuItem = gameData?.gameSnackbarInfo?.menuItems?.find(item => item.modal === activeModal);
  
  // If no content found, don't render
  if (!menuItem || !menuItem.content) {
    return null;
  }

  const { title, content } = menuItem;

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '325px',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#fff',
    padding: '22px',
    boxShadow: 24,
    borderColor: '#e5e7eb !important',
    borderRadius: '8px'
  };

  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  };

  const renderContent = (item, index) => {
    switch (item.type) {
      case 'paragraph':
        // Handle highlighted text within paragraphs
        if (item.highlightText && item.highlightWeight) {
          const parts = item.text.split(item.highlightText);
          return (
            <Typography
              key={index}
              sx={{
                fontWeight: item.fontWeight || '400',
                textAlign: item.textAlign || 'left',
                marginBottom: item.marginBottom || '16px'
              }}
            >
              {parts[0]}
              <span style={{ fontWeight: item.highlightWeight }}>
                {item.highlightText}
              </span>
              {parts[1]}
            </Typography>
          );
        }
        
        return (
          <Typography
            key={index}
            sx={{
              fontWeight: item.fontWeight || '400',
              textAlign: item.textAlign || 'left',
              marginBottom: item.marginBottom || '16px'
            }}
          >
            {item.text}
          </Typography>
        );

      case 'image':
        return (
          <Box key={index} sx={{ marginBottom: item.marginBottom || '16px' }}>
            <img
              style={{
                display: 'block',
                margin: '0 auto',
                maxWidth: '100%',
                height: 'auto'
              }}
              src={item.src}
              alt={item.alt || ''}
            />
          </Box>
        );

      case 'button':
        return (
          <Button
            key={index}
            sx={{
              margin: item.marginBottom ? `0 auto ${item.marginBottom}` : '0 auto',
              display: 'block',
              padding: '4px 12px'
            }}
            className="my-pools-card-button"
            onClick={() => {
              if (item.linkType === 'external') {
                window.open(item.url, '_blank', 'noopener,noreferrer');
              } else if (item.linkType === 'internal') {
                // Handle internal navigation if needed
                window.location.href = item.url;
              }
            }}
          >
            {item.text}
            {item.showIcon && <EastIcon sx={{ fontSize: '16px', marginBottom: '1px' }} />}
          </Button>
        );

      case 'link':
        if (item.linkType === 'external') {
          return (
            <MuiLink
              key={index}
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#00AAD1',
                display: 'block',
                marginBottom: item.marginBottom || '10px',
                textDecoration: 'underline'
              }}
            >
              {item.text}
            </MuiLink>
          );
        } else {
          return (
            <MuiLink
              key={index}
              component={RouterLink}
              to={item.url}
              sx={{
                color: '#00AAD1',
                display: 'block',
                marginBottom: item.marginBottom || '10px',
                textDecoration: 'underline'
              }}
            >
              {item.text}
            </MuiLink>
          );
        }

      default:
        return null;
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalStyle}>
        <Box sx={modalHeaderStyle}>
          <Typography sx={{ fontWeight: '700', fontSize: '24px' }}>{title}</Typography>
          <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={onClose} />
        </Box>

        {content && content.map((item, index) => renderContent(item, index))}
      </Box>
    </Modal>
  );
};

export default ContentModal;